import Component from '@apps-pages/real-time/component';
/**
 * @import internal modules
 */
import {RealTimesActionCreator,StatsActionCreator } from "@apps-store/action-creator";

/**
 * @import external modules
 */

import * as React from "react";
import { connect } from "react-redux";
import { Dispatch , bindActionCreators } from "redux";
import * as Utils from '@root-utils/index';
import * as moment from 'moment'
import * as Lodash from 'lodash';


class Container extends React.PureComponent<any, any> {
    /**
     * @public
     * @constructor
     * @param { any } props 
     * @return { }
     */
    public constructor(props: any){

        super(props);

        this.state = { content: [] , globalArray: [], contentFiveClass: [] };
     
        this.onPlayPause = this.onPlayPause.bind(this);
    }

    /**
     * manipulation des valeurs des inputs
     * @public
     * @method onPlayPause
     * @param { React.ChangeEvent<HTMLInputElement>  }  event
     * @return {any }
     */
    public onPlayPause = (event: React.ChangeEvent<HTMLInputElement>) =>{

        event.preventDefault();

        const PlayAndPause: any = document.querySelector("#play-and-pause");

        if(PlayAndPause !== null){ 

            if(PlayAndPause.textContent === "Play"){

                PlayAndPause.innerHTML = "Pause";

                this.onSetInterval();

            }else if(PlayAndPause.textContent === "Pause"){

                PlayAndPause.innerHTML = "Play";
                clearInterval(this.state.clearInterval)
                
            }
        }
      
    }
    /**
     * @method onSetInterval
     * @param {}
     * @return {}
     */
    public onSetInterval = () => {
        
        this.props.RealTimesActionCreator();

        const clearInterval= setInterval(() => this.props.RealTimesActionCreator(), 1000) ;

        this.setState({clearInterval});
     }
    /**
     * Cycle de vie de React : componentDidMount
     * @public
     * @method componentDidMount
     * @param {}
     * @return { any }
     */
    public componentDidMount = () => {this.onSetInterval(); this.props.StatsActionCreator();}
    /**
     * Cycle de vie de React : componentDidMount
     * @public
     * @method componentDidMount
     * @param {}
     * @return { any }
     */
    public componentWillUnmount = () => clearInterval(this.state.clearInterval)

    /**
     * name
     */
    public removeSec = (datetime : any): any =>{
       
        return moment(datetime).seconds(0).milliseconds(0).toISOString().replace(":00.000Z","");
        
    }
    /**
     * Cycle de vie React : componentWillReceiveProps
     * @public
     * @method componentWillReceiveProps
     * @param { any  }  nextProps
     * @return {any }
     */
    public componentWillReceiveProps = (nextProps: any) =>{
        
        
        if(nextProps.error !== this.props.error){ console.log(nextProps.error) }

        else if(nextProps.data !== this.props.data){
            
            if(!Lodash.isUndefined(nextProps.data)){
            
            const content: any[] = Utils.removeDuplicateObject(Utils.transformObjectToArray(nextProps.data),"prod") ;
           
                
            const globalArray: any[] = this.state.globalArray;

            content.map(( item: any, index:number) => {

                const tsIndex = globalArray && globalArray.findIndex((o:any) =>  {

                    return o.timestampRef === this.removeSec(item['@timestamp'])

                })

                if( tsIndex !== -1 ){

                    globalArray[tsIndex].imageDatas.push(item)

                    globalArray[tsIndex].imageDatas = Utils.removeDuplicateObject(globalArray[tsIndex].imageDatas,"timestamp")
                
                } else{

                    globalArray.push(
                    {
                        "imageDatas" : [],
                        "timestampRef" : this.removeSec(item['@timestamp']),
                    })

                    const tsIndexs = globalArray && globalArray.findIndex((o:any) =>  {

                        return o.timestampRef === this.removeSec(item['@timestamp']);

                    })

                    globalArray[tsIndexs].imageDatas.push(item);

                }
            })

            /**
             * Filtrer le tableau des elements
             * 
             * 
             */
            
            
            if( localStorage.getItem("classFive") !=="undefined" && localStorage.getItem("classFive") !== null){

                const getClassStorage: any = localStorage.getItem("classFive");

                const TableStorage: any[] = JSON.parse(getClassStorage);
                
                const contentFive: any[] = content &&  Utils.filterScoreAndPredifClassif(content,5);

                const concatClass : any[] = TableStorage.concat(contentFive);
                    
                const concatSort : any[] = Utils.dynamicSortByTimeStamp(concatClass); 
                
                const contentFiveClass = concatSort && Utils.removeDuplicateObject(concatSort.slice(-4),"prod");
                
                this.setState({ content, globalArray, contentFiveClass });

                localStorage.setItem("classFive",JSON.stringify(contentFiveClass));
            }else{
                localStorage.setItem("classFive",JSON.stringify([]));
            }


            }
               
            // const clas


        }
    } 
    /**
     * Cycle de vie de React : render
     * @public
     * @method render
     * @param {}
     * @return { any }
     */
    public render() {
      
        return <Component {...this.props} {...this.state} onPlayPause={this.onPlayPause} />
    }
}

/**
 * @function mapStateToProps
 * @param { any }  state 
 * @return { any }
 */
const mapStateToProps = (state : any) => ({ data:state.realTimes.data , error:state.realTimes.error });


const mapDispatchToProps = (dispatch : Dispatch) =>
    bindActionCreators({
        RealTimesActionCreator,
        StatsActionCreator,
       
    }, dispatch);


export default connect(mapStateToProps,mapDispatchToProps)(Container);







// WEBPACK FOOTER //
// ./src/apps/components/@pages/real-time/container.tsx